import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import Inspection from './Inspection';

// Wrapper that loads existing inspection data and passes it to the form
export default function InspectionEdit() {
  const { id }   = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [existing, setExisting] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await api.get(`/inspections/${id}`);
        const insp = data.inspection;

        // Only manager who submitted can edit (if still submitted)
        if (
          user.role === 'manager' &&
          (insp.submittedBy?._id !== user.id || insp.status !== 'submitted')
        ) {
          navigate(`/inspection/${id}`);
          return;
        }

        setExisting(insp);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load inspection');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id, user, navigate]);

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--dark)', color: 'var(--cyan)', fontFamily: 'Inter, sans-serif' }}>
      Loading inspection...
    </div>
  );

  if (error) return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--dark)', fontFamily: 'Inter, sans-serif', gap: '16px' }}>
      <div style={{ color: 'var(--red)' }}>{error}</div>
      <button onClick={() => navigate(-1)} style={{ background: 'var(--dark2)', border: '1px solid var(--border)', color: '#fff', borderRadius: '8px', padding: '8px 18px', cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
    </div>
  );

  return <Inspection existingData={existing} editMode inspectionId={id} />;
}
